export default "__VITE_ASSET__LOG9WLQG__"